





































import { Component, Vue } from "vue-property-decorator";
import HeartIcon from "../../../assets/icons/HeartIcon.vue";
import RulerIcon from "../../../assets/icons/RulerIcon.vue";
import ConnectionIcon from "../../../assets/icons/ConnectionIcon.vue";
import FacesIcon from "../../../assets/icons/FacesIcon.vue";
import BarIcon from "../../../assets/icons/BarIcon.vue";
import { Getter } from "vuex-class";
import { Form } from "../../../interfaces";

@Component({
  components: {
    appHeartIcon: HeartIcon,
    appRulerIcon: RulerIcon,
    appConnectionIcon: ConnectionIcon,
    appFacesIcon: FacesIcon,
    appBarIcon: BarIcon,
  },
})
export default class ToolsHome extends Vue {
  @Getter("pulseForms", { namespace: "form" }) pulseForms!: Array<Form>;
  @Getter("rulerForms", { namespace: "form" }) rulerForms!: Array<Form>;
  @Getter("aqcForms", { namespace: "form" }) aqcForms!: Array<Form>;
  @Getter("pcoForms", { namespace: "form" }) pcoForms!: Array<Form>;
  @Getter("av360Forms", { namespace: "form" }) av360Forms!: Array<Form>;

  get isAnyPulseFormNotAnswered(): boolean {
    return this.pulseForms.filter((form) => form.answered === false).length > 0;
  }

  get isAnyRulerFormNotAnswered(): boolean {
    return this.rulerForms.filter((form) => form.answered === false).length > 0;
  }

  get isAnyAQCFormNotAnswered(): boolean {
    return this.aqcForms.filter((form) => form.answered === false).length > 0;
  }

  get isAnyPCOFormNotAnswered(): boolean {
    return this.pcoForms.filter((form) => form.answered === false).length > 0;
  }

  get isAnyAV360FormNotAnswered(): boolean {
    return this.av360Forms.filter((form) => form.answered === false).length > 0;
  }
}
